export const FIND_ALL_MEAL_CATEGORIES_REQUEST = 'FIND_ALL_MEAL_CATEGORIES_REQUEST';

export const findAllMealCategoriesRequest = () => ({
    type: FIND_ALL_MEAL_CATEGORIES_REQUEST,
});
